import {on, find, findAllIn, addClass, removeClass, hasClass} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    console.log("init popovers");
    onFind(".js-toggle-popover", function (element) {
        console.log("popoverTriggerList", element);
    });
}
